/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Сообщение об ошибкe валидации
 */
export interface ValidationErrorItem {
  /** Сообщение об ошибке */
  message?: string;

  /** Поля, содержащие ошибку */
  fields?: string[];
}

/**
 * Сообщение об ошибках валидации
 */
export interface ValidationErrorMessage {
  /** Ошибки валидации */
  errors?: ValidationErrorItem[];

  /** Дата и время возникновения ошибок валидации */
  timestamp?: string;
}

/**
 * Ошибка валидации
 */
export interface ErrorMessage {
  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Вид приложения
 * @example WEB
 */
export enum ApplicationType {
  WEB = "WEB",
  MOBILE = "MOBILE",
  ALL = "ALL",
}

/**
 * Вид объекта
 * @example TARIFF_PLAN
 */
export enum EntityType {
  SERVICE = "SERVICE",
  TARIFF_PLAN = "TARIFF_PLAN",
}

/**
 * Запрос на создание/редактирование Заявки на смену тарифного плана
 */
export interface OrderRequest {
  /**
   * Порядок взимания комиссионного вознаграждения
   * @example CHANGE
   */
  chargingCommission: "CURRENT" | "CHANGE" | "TARIFF";

  /**
   * Код нового тарифного плана, если не задан - тарифный план по умолчанию
   * @format int32
   * @example 8
   */
  newTariffCode?: number;

  /**
   * Номер действующего расчётного счета
   * @example 40702810335000001707
   */
  accountNumber: string;

  /**
   * Расчётный период
   * @format int32
   * @example 9
   */
  billingPeriod?: number;

  /**
   * Снять подписи с заявки
   * @example false
   */
  resetSign?: boolean;
}

/**
 * Разрешения пользователя
 */
export interface AccessRights {
  /** Разрешение на подпись */
  canSign: boolean;

  /** Комментарий к разрешению на подпись */
  canSignDesc?: string;

  /** Разрешение на редактирование */
  canEdit: boolean;

  /** Разрешение на удаление */
  canDelete: boolean;
}

/**
 * Ответ на создание/редактирование заявки на смену тарифного плана
 */
export interface OrderResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   * @example bc4d2666-ff74-4c7b-ad23-221739fb33e9
   */
  id?: string;

  /**
   * Номер заявки
   * @format int32
   * @example 5
   */
  number?: number;

  /**
   * Дата заявки
   * @format date
   * @example 2024-03-01
   */
  date?: string;

  /**
   * Статус заявки
   * @example PREPARED
   */
  state?: string;

  /**
   * Описание статуса заявки
   * @example Создана
   */
  stateDesc?: string;

  /**
   * Номер расчётного счёта
   * @example 40104020403040404050
   */
  accountNumber?: string;

  /**
   * Номер договора РКО
   * @example 3
   */
  agreementNumber?: string;

  /**
   * Дата смены тарифного плана
   * @format date
   * @example 2024-06-01
   */
  tariffChangeDate?: string;

  /**
   * Порядок взимания комиссионного вознаграждения
   * @example CHANGE
   */
  chargingCommission?: string;

  /**
   * Цифровой код нового тарифного плана
   * @format int32
   * @example 8
   */
  newTariffCode?: number;

  /**
   * Расчётный период
   * @format int32
   * @example 9
   */
  billingPeriod?: number;

  /**
   * Контактный телефон клиента
   * @example +74951234567
   */
  clientPhone?: string;

  /**
   * ФИО уполномоченного представителя клиента
   * @example Иванов И.И.
   */
  representativeName?: string;

  /**
   * Должность ФИО уполномоченного представителя клиента
   * @example директор
   */
  representativePosition?: string;

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;
}

export type EmptyResponse = object;

/**
 * Заявки на смену тарифного плана
 */
export interface OrdersResponse {
  /** Наличие у пользователя права на создание новых Заявок */
  canCreate?: boolean;

  /** Наличие у пользователя права на подпись Заявок */
  canSign?: boolean;

  /** Признак наличия следующей страницы справок при постраничной выдаче */
  hasMore?: boolean;

  /** Перечень Заявок на смену тарифного плана */
  orders?: OrderResponse[];
}

/**
 * Стоимость услуги тарифного плана
 */
export interface ServiceCost {
  /**
   * Идентификатор услуги тарифного плана
   * @format uuid
   * @example 31aaeb20-fcf5-4248-bd4e-f1e8d779c472
   */
  serviceId: string;

  /** Варианты стоимости услуги тарифного плана */
  serviceCostOptions?: ServiceCostOption[];
}

/**
 * Вариант стоимости услуги тарифного плана
 */
export interface ServiceCostOption {
  /**
   * Условие варианта стоимости услуги тарифного плана
   * @example при оплате за один год
   */
  condition?: string;

  /**
   * Стоимость услуги тарифного плана
   * @example 1000 рублей в месяц
   */
  cost: string;
}

/**
 * Тарифный план
 */
export interface TariffPlan {
  /**
   * Идентификатор тарифного плана
   * @format uuid
   * @example f0e87216-a350-4c8c-95a0-90aae056d593
   */
  id: string;

  /**
   * Наименование тарифного плана
   * @example Агропремиум
   */
  name: string;

  /**
   * Описание тарифного плана
   * @example Тарифный план Агропремиум
   */
  desc?: string;

  /**
   * Приоритет тарифного плана
   * @format int32
   * @example 1
   */
  position: number;

  /**
   * Цифровой код тарифного плана
   * @format int32
   * @example 18
   */
  code: number;

  /**
   * Примечание для тарифного плана
   * @example для новых клиентов банка
   */
  comment?: string;

  /**
   * Признак архивной записи
   * @example false
   */
  archived: boolean;

  /**
   * Отсутствует возможность перехода на тарифный план
   * @example false
   */
  notAvailable: boolean;

  /**
   * Тарифный план является тарифом по умолчанию
   * @example false
   */
  isDefault: boolean;

  /**
   * Признак доступности тарифного плана в иностранной валюте
   * @example false
   */
  useCurrency: boolean;

  /**
   * Признак использования расчетного периода для тарифного плана
   * @example false
   */
  useCalcPeriod: boolean;

  /**
   * Ссылка для получения информации по тарифному плану
   * @example https://www.rshb.ru/smallbusiness/rko/
   */
  url: string;

  /** Стоимости услуг тарифного плана */
  serviceCosts?: ServiceCost[];

  /** Идентификаторы картинок тарифного плана */
  images?: string[];
}

/**
 * Услуги
 */
export interface TariffPlans {
  /** Список тарифных планов */
  tariffPlans: TariffPlan[];
}

/**
 * Услуга
 */
export interface Service {
  /**
   * Идентификатор услуги
   * @format uuid
   * @example 07202fb9-192e-4714-81c9-981c1a1ebe2c
   */
  id: string;

  /**
   * Наименование услуги
   * @example Внесение наличных денежных средств
   */
  name: string;

  /**
   * Описание услуги
   * @example Внесение наличных денежных средств через кассу
   */
  desc?: string;

  /**
   * Услуга входит в основную группу
   * @example true
   */
  general: boolean;

  /**
   * Услуга является стоимостью обслуживания
   * @example false
   */
  subscriptionFee: boolean;

  /**
   * Наименование группы услуги
   * @example Платежи и переводы
   */
  groupName?: string;

  /**
   * Приоритет группы услуги
   * @format int32
   * @example 1
   */
  groupPosition?: number;

  /** Идентификаторы картинок услуги */
  images?: string[];
}

/**
 * Услуги
 */
export interface Services {
  /** Список услуг */
  services: Service[];
}

/**
 * Картинка
 */
export interface Image {
  /**
   * Идентификатор картинки
   * @format uuid
   * @example d1a8ca78-1321-434f-bae7-bd4e3e786221
   */
  id: string;

  /**
   * Наименование картинки
   * @example Тарифный план Агророст
   */
  name: string;

  /** Вид приложения */
  applicationType: ApplicationType;

  /** Вид объекта */
  entityType: EntityType;

  /** Имя файла картинки */
  fileName: string;

  /** Картинка (BASE64) */
  file: string;
}

/**
 * Картинки
 */
export interface Images {
  /** Набор картинок */
  images: Image[];
}

/**
 * Договор ЕСД клиента
 */
export interface Esd {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Номер договора ЕСД */
  number?: string;

  /**
   * Дата договора ЕСД
   * @format date
   */
  date?: string;
}

/**
 * Получение ККБ конкретного документа
 */
export interface DocumentCcbResponse {
  /** ККБ документа */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: CcbDocument;
}

/**
 * Документ
 */
export interface CcbDocument {
  /** Поля документа */
  fields?: CcbOrder;

  /** Тип документа */
  type?: DocumentType;
}

/**
 * Поля документа
 */
export type CcbOrder = object;

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование вида заявки */
  name?: string;

  /** Описание вида заявки */
  desc?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId: string;
}

/**
 * Расчётный счёт клиента
 */
export interface Account {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Наименование */
  name?: string;

  /** ФИО подопечного */
  wardName?: string;

  /** Номер */
  number?: string;

  /** Буквенный ISO-код валюты */
  currency?: string;

  /** Текущий остаток */
  currentBalance?: number;

  /** Тип счета (расчетный, депозитный, etc) */
  type?: string;

  /** Признак, что этот счет используется по умолчанию */
  isDefaultAccount?: boolean;
}

export interface GetOrdersParams {
  accountNumber?: string;
  state?: string;

  /** @format int32 */
  position?: number;

  /** @format int32 */
  size?: number;
}

export interface GetTariffPlanParams {
  /** @format uuid */
  accountId: string;
}

export interface GetImages1Params {
  applicationType?: "WEB" | "MOBILE" | "ALL";
  entityType?: "SERVICE" | "TARIFF_PLAN";
}

export interface GetChangeDateParams {
  /** @format date */
  changeDate: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-tariff-plans
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-tariff-plans.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Тарифы <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=265898853)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Заявки на смену тарифного плана
     * @name GetOrder
     * @summary Получение заявки на смену тарифного плана
     * @request GET:/api/tariffs/external/v1/order/{id}
     * @secure
     */
    getOrder: (id: string, params: RequestParams = {}) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/tariffs/external/v1/order/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на смену тарифного плана
     * @name EditOrder
     * @summary Редактирование заявки на смену тарифного плана
     * @request PUT:/api/tariffs/external/v1/order/{id}
     * @secure
     */
    editOrder: (id: string, data: OrderRequest, params: RequestParams = {}) =>
      this.request<OrderResponse, ErrorMessage | ValidationErrorMessage>({
        path: `/api/tariffs/external/v1/order/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на смену тарифного плана
     * @name DeleteOrder
     * @summary Удаление заявки на смену тарифного плана
     * @request DELETE:/api/tariffs/external/v1/order/{id}
     * @secure
     */
    deleteOrder: (id: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/tariffs/external/v1/order/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на смену тарифного плана
     * @name GetOrders
     * @summary Получение заявок на смену тарифного плана
     * @request GET:/api/tariffs/external/v1/order
     * @secure
     */
    getOrders: (query: GetOrdersParams, params: RequestParams = {}) =>
      this.request<OrdersResponse, ErrorMessage | ValidationErrorMessage>({
        path: `/api/tariffs/external/v1/order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на смену тарифного плана
     * @name CreateOrder
     * @summary Создание заявки на смену тарифного плана
     * @request POST:/api/tariffs/external/v1/order
     * @secure
     */
    createOrder: (data: OrderRequest, params: RequestParams = {}) =>
      this.request<OrderResponse, ErrorMessage | ValidationErrorMessage>({
        path: `/api/tariffs/external/v1/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на смену тарифного плана
     * @name GetTariffPlan
     * @summary Получить тарифный план
     * @request GET:/api/tariffs/external/v1/order/tariff-plan
     * @secure
     */
    getTariffPlan: (query: GetTariffPlanParams, params: RequestParams = {}) =>
      this.request<TariffPlan, ErrorMessage>({
        path: `/api/tariffs/external/v1/order/tariff-plan`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetTariffPlans1
     * @summary Получение списка тарифных планов
     * @request GET:/api/tariffs/external/v1/dict/tariff-plans
     * @secure
     */
    getTariffPlans1: (params: RequestParams = {}) =>
      this.request<TariffPlans, ErrorMessage>({
        path: `/api/tariffs/external/v1/dict/tariff-plans`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetServices1
     * @summary Получение списка услуг
     * @request GET:/api/tariffs/external/v1/dict/service
     * @secure
     */
    getServices1: (params: RequestParams = {}) =>
      this.request<Services, ErrorMessage>({
        path: `/api/tariffs/external/v1/dict/service`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetImages1
     * @summary Получение списка картинок
     * @request GET:/api/tariffs/external/v1/dict/images
     * @secure
     */
    getImages1: (query: GetImages1Params, params: RequestParams = {}) =>
      this.request<Images, ErrorMessage>({
        path: `/api/tariffs/external/v1/dict/images`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetImage1
     * @summary Получение картинки
     * @request GET:/api/tariffs/external/v1/dict/images/file/{id}
     */
    getImage1: (id: string, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/tariffs/external/v1/dict/images/file/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetEsd
     * @summary Получение действующего договора ЕСД клиента
     * @request GET:/api/tariffs/external/v1/dict/esd
     * @secure
     */
    getEsd: (params: RequestParams = {}) =>
      this.request<Esd, ErrorMessage>({
        path: `/api/tariffs/external/v1/dict/esd`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags confirmation
     * @name GetTlsRequestCcb
     * @summary Получение ККБ Заявки смену тарифного плана
     * @request GET:/api/tariffs/external/v1/confirmation/document-ccb/order/{id}
     * @secure
     */
    getTlsRequestCcb: (id: string, params: RequestParams = {}) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/tariffs/external/v1/confirmation/document-ccb/order/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags confirmation
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения для клиента
     * @request GET:/api/tariffs/external/v1/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/tariffs/external/v1/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetAccounts
     * @summary Получение расчётных счетов клиента
     * @request GET:/api/tariffs/external/v1/dict/account
     * @secure
     */
    getAccounts: (params: RequestParams = {}) =>
      this.request<Account[], ErrorMessage>({
        path: `/api/tariffs/external/v1/dict/account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetCommissionPaymentTerms
     * @summary Получение справочника расчётных периодов
     * @request GET:/api/tariffs/external/v1/dict/commission-terms
     * @secure
     */
    getCommissionPaymentTerms: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/tariffs/external/v1/dict/commission-terms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на смену тарифного плана
     * @name GetChangeDate
     * @summary Запрос из АБС даты начала действия нового тарифного план
     * @request GET:/api/tariffs/external/v1/order/change-date
     * @secure
     */
    getChangeDate: (query: GetChangeDateParams, params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/tariffs/external/v1/order/change-date`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты клиента
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/tariffs/external/v1/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/tariffs/external/v1/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
